<!-- E:\workspace_yongli\as_client\src\pages\system\mq_error_log_detail.vue -->
<template>
    <c-dialog ref="dialog" title="MQ错误日志详情" enable-flex width="800" mode="slide" mask-close :button="false">
        <div class="m-detail-box">
            <c-detail>
                <c-detail-item label="队列名称">
                    {{detailData.queues}}
                </c-detail-item>
                <c-detail-item label="Exchange">
                    {{detailData.exchange || '-'}}
                </c-detail-item>
                <c-detail-item label="Routing Key">
                    {{detailData.routing_key || '-'}}
                </c-detail-item>
                <c-detail-item label="处理状态">
                    <c-state dict="mqErrorLogFlagDic" tag :value="detailData.flag"></c-state>
                </c-detail-item>
                <c-detail-item label="创建时间">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item label="消息体">
                    <pre class="mq-pre">{{detailData.message}}</pre>
                </c-detail-item>
                <c-detail-item label="错误信息">
                    <pre class="mq-pre mq-error">{{detailData.error_log || '-'}}</pre>
                </c-detail-item>
                <c-detail-item label="消息头">
                    <pre class="mq-pre">{{detailData.header || '-'}}</pre>
                </c-detail-item>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'mqErrorLogDetail',

    computed: {
        ...mapState(['mqErrorLogFlagDic'])
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open(data) {
            this.detailData = data.detail || {};
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
.mq-pre {
    white-space: pre-wrap;
    word-break: break-all;
    margin: 0;
    font-size: 13px;
    line-height: 1.6;
    background: #f8f8f8;
    padding: 8px 12px;
    border-radius: 4px;
    max-height: 300px;
    overflow: auto;
}
.mq-error {
    color: #FF5555;
    background: #FFF5F5;
}
</style>